import {input, iti} from './intlTelInput'
import * as smartWizard from 'smartwizard'
import 'dirrty/dist/jquery.dirrty.js'
import helpers from './helpers'
import Lang from '../../lang'

function getPedigreesData($form) {
    let result = {}

    $form.find(':input[name^="pedigrees"]').each(function () {
        let match = this.name.match(/^pedigrees(?:\[(\w+)\])+$/)
        if (match) {
            let keys = this.name.match(/\[(\w+)\]/g).map(s => s.slice(1, -1))
            let lastKey = keys.pop()
            let pointer = result

            keys.forEach(key => {
                if (!pointer[key]) {
                    pointer[key] = {}
                }
                pointer = pointer[key]
            })

            let value = $(this).val()
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }

            pointer[lastKey] = value
        }
    })

    return result
}

let $wizardInstance = null

let registrationWizard = {
    preventJump(error = false) {
        setTimeout(function () {
            var menuHeight = $('header').height()

            if (error)
                var scrollTo =
                    $('.hs-popup.has-wizard-fm .has-error')
                        .first()
                        .offset().top -
                    menuHeight -
                    30
            else var scrollTo = $('.hs-popup.has-wizard-fm').offset().top - menuHeight - 30

            $('body,html').animate({scrollTop: scrollTo}, 100)
        }, 1)
    },

    onLeaveStep(anchorObject, stepNumber, stepDirection) {
        const form = $(`#step-fm-${stepNumber + 1} form`)[0]
        form && form.reportValidity()

        let isValid
        const elmForm = $('.hs-popup.has-wizard-fm #step-fm-' + (stepNumber + 1) + ' .form-section')

        // stepDirection === 'forward' :- this condition allows to do the form validation
        // only on forward navigation, that makes easy navigation on backwards still do the validation when going next
        if (stepDirection === 'forward' && elmForm) {
            elmForm.validator('validate')
            let elmErr = elmForm.children('.has-error')
            isValid = !(elmErr && elmErr.length > 0)
        }

        if (stepDirection === 'forward' && !isValid) {
            registrationWizard.preventJump(error)
        } else {
            registrationWizard.preventJump()
        }

        return isValid
    },

    onShowStep(anchorObject, stepNumber, stepDirection) {
        // Enable finish button only on last step
        if (stepNumber === 3) {
            $('.btn-finish').removeClass('disabled')
            //$('.sw-btn-prev').addClass('disabled force-disabled')
            $('.step-anchor li.nav-item').addClass('disabled')
        } else {
            $('.btn-finish').addClass('disabled')
            $('.sw-btn-prev').removeClass('disabled force-disabled')
            $('.step-anchor li.nav-item').removeClass('disabled')
        }

        if (stepNumber === 0) {
            $('.sw-btn-prev').addClass('disabled')
        } else {
            $('.sw-btn-prev').removeClass('disabled')
        }

        registrationWizard.enableButtons()

        // Scroll to top when the step content changes
        $('html, body').animate({scrollTop: 0}, 'slow')
    },

    submitStep(data, step) {
        $('#registration-loading').removeClass('d-none')
        registrationWizard.disableButtons()
        const containsFile = data instanceof FormData

        let result

        $.ajax({
            url: route('event-horse-registration.store', $('#userId').val()),
            method: 'POST',
            data,
            processData: containsFile ? false : undefined,
            contentType: containsFile ? false : undefined,
            dataType: 'JSON',
        }).done(responseData => {
            $('#registration-loading').addClass('d-none')

            result = responseData.success

            const stepSent = containsFile ? data.get('step') : data.step

            if (!result) {
                helpers.showHorseRegistrationAlert(
                    `#alert-container-${stepSent}`,
                    'danger',
                    responseData.errors.message,
                )
            } else {
                $(`#step-fm-${step + 1} form`).removeData('should-save')
                $wizardInstance.data('smartWizard')._transitPage(step + 1)

                if (responseData.step == 2) {
                    $('#registrationId').val(responseData.horseRegistrationId)
                }

                if (responseData.step == 3) {
                    // Reset the radio button selection
                    $('input[type="radio"][name="event_id"]').prop('checked', false)

                    // Remove the active class from the label element
                    $('input[type="radio"][name="event_id"]').parent('label').removeClass('active')
                }

                if (responseData.step == 4) {
                    this.handleStepFourReview(responseData)
                }
            }

            registrationWizard.enableButtons()
        })

        return result
    },

    init($element, step) {
        $wizardInstance = $element.smartWizard({
            selected: step,
            toolbarSettings: {
                toolbarPosition: 'none',
                toolbarButtonPosition: 'right',
                showNextButton: true,
                showPreviousButton: true,
                keyNavigation: false,
                anchorSettings: {
                    markDoneStep: true, // add done css
                    markAllPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
                    removeDoneStepOnNavigateBack: true, // While navigate back done step after active step will be cleared
                    enableAnchorOnDoneStep: true, // Enable/Disable the done steps navigation
                },
                toolbarExtraButtons: [],
            },
            useURLhash: true,
            showStepURLhash: true,
            backButtonSupport: true,

            lang: {
                next: Lang.get('javascript.title.continue'),
                previous: Lang.get('javascript.title.back'),
            },
        })

        if ($('.hs-popup.has-wizard-fm #step-1').is(':visible')) {
            $('.sw-btn-prev').addClass('disabled')
        } else {
            $('.sw-btn-prev').removeClass('disabled')
        }

        if ($('.sw-container .step-content:last-child').is(':visible')) {
            $('.btn-finish').removeClass('disabled')
            $('.sw-btn-prev').addClass('disabled')
        } else {
            $('.btn-finish').addClass('disabled')
            $('.sw-btn-prev').removeClass('disabled')
        }

        $('.hs-popup.has-wizard-fm form .form-section').each(function () {
            $(this).validator({
                focus: true,
            })
        })

        $('.btn-finish').on('click', function () {
            const isFinishAndRegisterAgain = $(this).hasClass('btn-finish-and-register-again')

            $(this).attr('disabled', 'disabled')
            $('#registration-loading').removeClass('d-none')
            registrationWizard.disableButtons()

            const data = {
                step: 4,
                user_id: $('#userId').val(),
                horse_registration_id: $('#registrationId').val(),
                event_id: $('#eventId').val(),
                sale_status: $('input[name="sale_status"]:checked').val(),
                sale_is_for_h24_championship: $('input[name="sale_is_for_h24_championship"]:checked').val() == 'on',
                sale_is_for_breeding_association_auction: $('input[name="sale_is_for_breeding_association_auction"]:checked').val() == 'on',
                sale_is_private: $('input[name="sale_is_private"]:checked').val() == 'on',
            }

            $.ajax({
                url: route('event-horse-registration.store', $('#userId').val()),
                method: 'POST',
                data,
                dataType: 'JSON',
            }).done(responseData => {
                $('#registration-loading').addClass('d-none')

                const result = responseData.success

                if (!result) {
                    helpers.showHorseRegistrationAlert(
                        `#alert-container-${data.step}`,
                        'danger',
                        responseData.errors.message,
                    )
                } else {
                    $(this).removeAttr('disabled')

                    if (responseData.horseRegistrationCompleted) {
                        window.location.href = 'register-your-foal-or-mare/thanks'

                        /*if (isFinishAndRegisterAgain) {
                            window.location.reload()
                            //window.location.href = `${location.host}${location.pathname}`
                        } else {
                            window.location.href = 'register-your-foal-or-mare/thanks'
                        }*/
                    }
                }

                registrationWizard.enableButtons()
            })
        })
    },

    clearErrorsMessages(stepNumber) {
        $(`#alert-container-${stepNumber}`)
            .text('')
            .addClass('d-none')
    },

    execute(step) {
        const $wizard = $('.hs-popup.has-wizard-fm')

        if ($wizard.length) {
            registrationWizard.init($wizard, step)

            $wizard.on('leaveStep', (e, anchorObject, stepNumber, stepDirection) => {
                const shouldSave = $(`#step-fm-${stepNumber + 1} form`).data('should-save')

                if (stepNumber !== 0 && shouldSave !== undefined && shouldSave === false) {
                    return true
                }

                let validation = registrationWizard.onLeaveStep(
                    anchorObject,
                    stepNumber,
                    stepDirection,
                )

                if (validation !== undefined && !validation) {
                    return false
                } else {
                    let stepData

                    switch (stepNumber) {
                        case 0:
                            stepData = {
                                step: 1,
                                user_id: $('#userId').val(),
                                horse_registration_id: $('#registrationId').val(),

                                registered_as: this.getRegisteredAsValue(),

                                owner_title: $('#owner_title').val(),
                                owner_firstname: $('#owner_firstname').val(),
                                owner_lastname: $('#owner_lastname').val(),
                                owner_name: $('#owner_name').val(),
                                //owner_date_of_birth: $('#owner_birthday').val(),
                                owner_email: $('#owner_email').val(),
                                owner_address1: $('#owner_address1').val(),
                                owner_address2: $('#owner_address2').val(),
                                owner_zip: $('#owner_zip').val(),
                                owner_city: $('#owner_city').val(),
                                owner_country_id: $('#owner_country_id').val(),
                                //owner_calling_code: iti.getSelectedCountryData().dialCode,
                                owner_telephone: $('#owner_telephone').val(),
                                //owner_country: iti.getSelectedCountryData().name,

                                breeder_title: $('#breeder_title').val(),
                                breeder_firstname: $('#breeder_firstname').val(),
                                breeder_lastname: $('#breeder_lastname').val(),
                                breeder_name: $('#breeder_name').val(),
                                //breeder_date_of_birth: $('#breeder_birthday').val(),
                                breeder_email: $('#breeder_email').val(),
                                breeder_address1: $('#breeder_address1').val(),
                                breeder_address2: $('#breeder_address2').val(),
                                breeder_zip: $('#breeder_zip').val(),
                                breeder_city: $('#breeder_city').val(),
                                breeder_country_id: $('#breeder_country_id').val(),
                                //breeder_calling_code: iti.getSelectedCountryData().dialCode,
                                breeder_telephone: $('#breeder_telephone').val(),
                                //breeder_country: iti.getSelectedCountryData().name,
                            }
                            break
                        case 1:
                            const horseType = this.getHorseType()

                            stepData = new FormData()
                            stepData.append('step', 2)
                            stepData.append('user_id', $('#userId').val())
                            stepData.append('horse_registration_id', $('#registrationId').val())
                            stepData.append('horse_type', this.getHorseType())
                            stepData.append('type', this.getHorseSubType())
                            stepData.append('discipline', this.getHorseDiscipline())
                            stepData.append('sex', this.getHorseSex())
                            stepData.append('horse_name', $('#horse_name').val())
                            stepData.append('life_id_prefix', $('#life_id_prefix').val())
                            stepData.append('life_id', $('#life_id').val())
                            stepData.append('date_of_birth', $('#date_of_birth').val())
                            stepData.append('lot_color_id', $('#lot_color_id').val())
                            stepData.append('lot_breed_id', $('[name="lot_breed_id"]').val())
                            //stepData.append('vat_for_sale', $('#vat_for_sale').val())
                            //stepData.append('sale_status', $('#sale_status').val())

                            const pedigree = getPedigreesData($('form'))
                            stepData.append('pedigrees', JSON.stringify(pedigree))

                            // Handle mare score file upload
                            if (horseType === 'Mare') {
                                const mareScore = document.getElementById('mare_score_files')

                                if (mareScore.files && mareScore.files[0]) {
                                    stepData.append('mare_score_files', mareScore.files[0])
                                }
                            }

                            // Handle Pedigree files upload
                            const pedigreeFiles = document.getElementById('pedigree_files')

                            if (pedigreeFiles.files && pedigreeFiles.files[0]) {
                                stepData.append('pedigree_files', pedigreeFiles.files[0])
                            }
                            break
                        case 2:
                            stepData = {
                                step: 3,
                                user_id: $('#userId').val(),
                                horse_registration_id: $('#registrationId').val(),
                                event_id: $('input[name="event_id"]:checked').val(),
                            }
                            break
                        case 3:
                            stepData = {
                                step: 4,
                                user_id: $('#userId').val(),
                                horse_registration_id: $('#registrationId').val(),
                                sale_status: $('input[name="sale_status"]:checked').val(),
                                sale_is_for_h24_championship: $('input[name="sale_is_for_h24_championship"]:checked').val() == 'on',
                                sale_is_for_breeding_association_auction: $('input[name="sale_is_for_breeding_association_auction"]:checked').val() == 'on',
                                sale_is_private: $('input[name="sale_is_private"]:checked').val() == 'on',
                            }
                            break
                    }

                    if (stepDirection === 'forward' && stepData) {
                        registrationWizard.submitStep(stepData, stepNumber)

                        return false
                    }
                }

                return true
            })

            $wizard.on('showStep', function (e, anchorObject, stepNumber, stepDirection) {
                if (stepDirection === 'backward') {
                    $(`#step-${stepNumber + 1} form`)
                        .dirrty({
                            preventLeaving: false,
                        })
                        .on('dirty', function () {
                            $(this).data('should-save', true)
                        })
                        .on('clean', function () {
                            $(this).data('should-save', false)
                        })
                        .data('should-save', false)
                }

                registrationWizard.clearErrorsMessages(stepNumber)
                registrationWizard.onShowStep(anchorObject, stepNumber, stepDirection)

                $('html, body').animate({scrollTop: 0}, 'slow')
            })

            // Scroll to top when opening the page
            $wizardInstance.data('smartWizard')._transitPage(step)
        }
    },

    enableButtons() {
        $('.sw-toolbar button').removeAttr('disabled')
    },

    disableButtons() {
        $('.sw-toolbar button').attr('disabled', true)
    },

    getRegisteredAsValue() {
        const isOwner = $('.toggle-checkbox-owner').prop('checked')
        const isBreeder = $('.toggle-checkbox-breeder').prop('checked')

        if (isOwner && isBreeder) {
            return 'owner and breeder'
        } else if (isOwner) {
            return 'owner'
        } else if (isBreeder) {
            return 'breeder'
        } else {
            return 'not owner and not breeder'
        }
    },

    getCheckboxValue(checkedId, uncheckedId, checkedValue, uncheckedValue) {
        return $(checkedId).is(':checked') ? checkedValue : uncheckedValue
    },

    getHorseType() {
        if ($('#checkbox-mare').is(':checked')) {
            return 'Mare'
        } else if ($('#checkbox-foal').is(':checked')) {
            return 'Foal'
        } else {
            return ''
        }
    },

    getHorseSubType() {
        if ($('#checkbox-warmblood').is(':checked')) {
            return 'Warmblood'
        } else if ($('#checkbox-pony').is(':checked')) {
            return 'Pony'
        } else {
            return ''
        }
    },

    getHorseDiscipline() {
        if ($('#checkbox-dressage').is(':checked')) {
            return 'Dressage'
        } else if ($('#checkbox-jumping').is(':checked')) {
            return 'Jumping'
        } else {
            return ''
        }
    },

    getHorseSex() {
        if ($('#checkbox-colt').is(':checked')) {
            return 'Colt'
        } else if ($('#checkbox-filly').is(':checked')) {
            return 'Filly'
        } else {
            return ''
        }
    },

    handleStepFourOwnerBreeder(type, response) {
        const titles = ['Company', 'Breeder community']
        const info = response.horseRegistration[type]

        $(`#step4-${type}_fullname`).html(`${info.fullname}`)

        $(`#step4-${type}_date_of_birth`).html(info.date_of_birth)
        $(`#step4-${type}_telephone`).html(info.telephone)
        $(`#step4-${type}_email`).html(info.email)

        $(`#step4-${type}_address`).html(`${info.address1}`)
        $(`#step4-${type}_zip_city`).html(`${info.zip} ${info.city} `)
        $(`#step4-${type}_country`).html(`${info.country.name}`)
    },

    toggleOwnerBreederVisibility(owner, breeder) {
        $('#step4-owner-breeder-info').toggleClass('d-none', !owner && !breeder)
        $('#step4-owner-info').toggleClass('d-none', !owner)
        $('#step4-breeder-info').toggleClass('d-none', !breeder)
    },

    concatenateValues(separator, ...values) {
        return values.filter((value) => value !== null && value !== '').join(separator);
    },

    handleStepFourReview(response) {
        const registeredAs = response.horseRegistration.registered_as

        if (registeredAs === 'owner and breeder') {
            this.toggleOwnerBreederVisibility(false, false)
        } else if (registeredAs === 'not owner and not breeder') {
            this.toggleOwnerBreederVisibility(true, true)
            this.handleStepFourOwnerBreeder('owner', response)
            this.handleStepFourOwnerBreeder('breeder', response)
        } else if (registeredAs === 'owner') {
            this.toggleOwnerBreederVisibility(false, true)
            this.handleStepFourOwnerBreeder('breeder', response)
        } else if (registeredAs === 'breeder') {
            this.toggleOwnerBreederVisibility(true, false)
            this.handleStepFourOwnerBreeder('owner', response)
        }

        const horseName = response.horseRegistration.horse_name
        const horseLifeIdPrefix = response.horseRegistration.life_id_prefix
        const horseLifeId = response.horseRegistration.life_id

        const formattedNameAndId = (horseName ? horseName : '') +
            (horseName && horseLifeId ? ' | ' : '') +
            (horseLifeIdPrefix && horseLifeId ? `${horseLifeIdPrefix} ${horseLifeId}` : '')

        $('#step4-horse_name').html(formattedNameAndId)

        const horseType = response.translatedHorseRegistrationHorseType
        const type = response.translatedHorseRegistrationType
        const discipline = response.translatedHorseRegistrationDiscipline
        const sex = response.translatedHorseRegistrationSex
        const birth = moment.utc(response.horseRegistration.date_of_birth).locale(Lang.locale).format('DD.MM.YYYY');

        $('#step4-horse_details').html(this.concatenateValues(' / ', horseType, type, discipline, sex))

        $('#step4-horse_date_of_birth').html(`${birth}`)
        $('#step4-horse_color').html(`${response.horseRegistrationColor}`)
        $('#step4-horse_breed').html(`${response.horseRegistrationBreed}`)

        if (response.horseRegistrationHorseType === 'Mare') {
            $('#step4-horse_status_of_sale_wrap').hide()
            $('#step4-saleability').hide()
        } else {
            $('#step4-horse_status_of_sale_wrap').show()
            $('#step4-horse_status_of_sale').html(`${response.horseRegistration.sale_status}`)
        }

        $('#eventId').val(`${response.event.id}`)
        $('#step4-event_logo_thumb').attr('src', response.event.logo_thumb_url)

        $('#terms-of-use-wrap a').attr('href', response.event.term_link)

        $('#step4-event_name').html(`${response.event.name}`)
        const dateTime = moment.utc(response.event.start);
        const formatedDate = dateTime.locale(Lang.locale).format('LL')+ ' | '+ dateTime.clone().local().format('HH:mm')
        $('#step4-event_start').html(`${formatedDate}`)

        if(response.event.registration_end) {
            const registrationEndDateTime = moment.utc(response.event.registration_end);
            const formatedregistrationEndDate = registrationEndDateTime.locale(Lang.locale).format('LL') + ' | ' + registrationEndDateTime.clone().local().format('HH:mm')
            $('#step4-event_registration_end_wrap').removeClass('d-none')
            $('#step4-event_registration_end').html(`${formatedregistrationEndDate}`)
        } else {
            $('#step4-event_registration_end_wrap').addClass('d-none')
            $('#step4-event_registration_end').html('')
        }

        $('#step4-event_location').html(`
            ${response.event.address1} ${response.event.address2 || ''}, ${response.event.zip} ${response.event.city} - ${response.event.country}
        `)

        if (window.pedigreeComponent) {
            window.pedigreeComponent.$refs['horse-pedigree'].setPedigreeData(response.pedigree)
        }
    },
}

window.addEventListener('load', function () {
    registrationWizard.execute($('#steps-fm').data('current-step') - 1)

    if ($('#registration-fm-wrap').data('has-terms') === '"false"') {
        $('#registration-fm-wrap').removeClass('d-none')
    }
})

input &&
input.addEventListener('countrychange', function () {
    const data = iti.getSelectedCountryData()
    // const selectElm = $('#country_id').data('select')
    const inputElm = $('#country_name')

    // selectElm.val($(`option[data-country-code="${data.iso2}"]`).val())
    inputElm.val(data.name)
})
